import React from 'react';

import { Text } from '../text/Text';

const ModalText: React.FC = ({ children }) => {
  return (
    <Text size="sm" lineHeight="lg">
      {children}
    </Text>
  );
};

export default ModalText;
